export const MODEL_VERIDAS = {
    name: '',
    lastName: '',
    secondLastName: '',
    dob: null,
    gender: null,
    documentId: null,
}

export const loadScript = (src, callback = null, onError = null) => {
    const isScript = document.querySelector(`script[src="${src}"]`);
    if (isScript) {
        if (callback) callback();
        return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.type = 'application/javascript';
    script.async = true;

    script.onload = () => {
        if (callback) callback();
    };

    script.onerror = () => {
        if (onError) onError();
    };

    document.head.appendChild(script);
};
